import ExportToExcel from "./export-to-excel";

export default ExportToExcel;